export const pricingAudiences = ["horseman", "stable"] as const;

export type PricingAudience = (typeof pricingAudiences)[number];

export const initialPricingAudience: PricingAudience = "horseman";

/**
 * Resolves the tab an arrow/Home/End key should move to, following the
 * visual order of the tablist so Arabic reads the same way round.
 * Returns null when the key is not a tab-navigation key.
 */
export function nextPricingAudience(
  current: PricingAudience,
  key: string,
  isRtl: boolean,
): PricingAudience | null {
  const index = pricingAudiences.indexOf(current);

  if (index < 0) {
    return null;
  }

  const forward = isRtl ? "ArrowLeft" : "ArrowRight";
  const backward = isRtl ? "ArrowRight" : "ArrowLeft";
  const { length } = pricingAudiences;
  const at = (offset: number): PricingAudience =>
    pricingAudiences[((offset % length) + length) % length] ??
    pricingAudiences[0];

  switch (key) {
    case forward:
      return at(index + 1);
    case backward:
      return at(index - 1);
    case "Home":
      return pricingAudiences[0];
    case "End":
      return at(length - 1);
    default:
      return null;
  }
}
